import { connect } from 'react-redux';

import UsersView from './UsersView';
import { fetchUsers } from './UsersState';
import { fetchRoles } from '../roles/RolesState';
import { fetchOrganizationMembers } from '../organizations/OrganizationsState';

function mapStateToProps(state) {
  return {
    isOrganizationMembersLoaded: state.organizations.isOrganizationMembersLoaded,
    roles: state.roles.data && state.roles.data.response ? state.roles.data.response.roles : state.roles.data,
    currentOrganizationId: state.organizations ? state.organizations.currentOrganizationId : '',
    organizationMembers: state.organizations.organizationMembers ? state.organizations.organizationMembers.response : state.organizations.organizationMembers
  };
}
  
function mapDispatchToProps(dispatch) {
  return {
    fetchUsers: () => dispatch(fetchUsers()),
    fetchRoles: () => dispatch(fetchRoles()),
    fetchOrganizationMembers: (organizationId) => dispatch(fetchOrganizationMembers(organizationId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersView);


// WEBPACK FOOTER //
// ./src/modules/users/UsersViewContainer.js